var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html, LitElement } from 'lit';
import { property } from 'lit/decorators.js';
import { classMap } from 'lit/directives/class-map.js';
import styles from './NavBarItem.styles.js';
export class SgdfNavBarItem extends LitElement {
    constructor() {
        super(...arguments);
        this.active = false;
    }
    firstUpdated() {
        this.setAttribute('role', 'navbaritem');
    }
    render() {
        return html `
            <div
                class=${classMap({
            'sgdf-navbar-item': true,
            'navbar--active': this.active,
        })}
            >
                <slot></slot>
            </div>
        `;
    }
}
SgdfNavBarItem.styles = styles;
__decorate([
    property({ type: Boolean })
], SgdfNavBarItem.prototype, "active", void 0);
//# sourceMappingURL=NavBarItem.js.map